import React from "react";

type PropsType = {
  children: React.ReactNode;
};

const FormActionsContainer = ({ children }: PropsType) => <div className="TT-form-actions">{children}</div>;
export default FormActionsContainer;
